import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cuscd-hero-wrap" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "cuscd-banner-text" }
const _hoisted_4 = {
  key: 0,
  class: "cuscd-h1style"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "cuscd-overlay" }, null, -1)),
    _createElementVNode("img", {
      src: _ctx.backgroundImage,
      alt: _ctx.backgroundImageAltText,
      class: _normalizeClass(["cuscd-img-banner", _ctx.backgroundImageClass])
    }, null, 10, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _cache[0] || (_cache[0] = _createElementVNode("p", { class: "cuscd-small-title" }, "Welcome to the SLC Applicant Portal", -1)),
      (_ctx.oidcIsAuthenticated)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.decodeHTMLEncodedStr(_ctx.formatName(_ctx.oidcUser.nickname?.toLowerCase()))), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}